const init_ask_info = () => {
    const _loading = document.querySelector(".ai_loading");
    _loading.style.display = "none";
  
    const _btn_ask_info = document.querySelector(".prod-ask-for-info");
    _btn_ask_info.addEventListener("click", (event) => {
        const _ai_main = document.querySelector(".ai-back-drop");
        _ai_main.style.display = "block";
        var body = document.body;
        body.classList.add("bsh");
    });
    const _close_ask_info = document.querySelector(".close_ask_info");
    _close_ask_info.addEventListener("click", (event) => {
        const _ai_main = document.querySelector(".ai-back-drop");
        _ai_main.style.display = "none";
        //reset form
        reset_form();
    });
    const _btn_submit_ask_info = document.querySelector(".ai-form-btn");
    _btn_submit_ask_info.addEventListener("click", (event) => {
        doAddAskInfo();
    });

    const _email = document.getElementById("f_email");
    _email.addEventListener("input", (event) => {
        _email.classList.remove("input-error");
    })

    const _phone_number = document.getElementById("f_phone_number");
    _phone_number.addEventListener("input", (event) => {
        _phone_number.classList.remove("input-error");
    })

    const _message = document.getElementById("ask-info-message");
    _message.addEventListener("input", (event) => {
        _message.classList.remove("input-error");
    })
}

const reset_form = () => {
    var body = document.body;
    body.classList.remove("bsh");
    const _btn_submit_ask_info = document.querySelector(".ai-form-btn");
    _btn_submit_ask_info.style.display = "block";
    const _success_message = document.querySelector(".ai-form-success");
    _success_message.style.display = "none";

    const _email = document.getElementById("f_email");
    const _phone_number = document.getElementById("f_phone_number");
    const _message = document.getElementById("ask-info-message");

    _email.value = "";
    _phone_number.value = "";
    _message.value = "";

    _email.classList.remove("input-error");
    _phone_number.classList.remove("input-error");
    _message.classList.remove("input-error");
}

const doAddAskInfo = async () => {
  
    const _email = document.getElementById("f_email");
    const _phone_code = document.getElementById("f_phone_code");
    const _phone_number = document.getElementById("f_phone_number");
    const _message = document.getElementById("ask-info-message");

    const _success_message = document.querySelector(".ai-form-success");

    if (_email.value == "") {
        _email.classList.add("input-error");
        return
    }
    if (_phone_number.value == "") {
        _phone_number.classList.add("input-error");
        return
    }
    if (_message.value == "") {
        _message.classList.add("input-error");
        return
    }

      //hidden submit button
    const _loading = document.querySelector(".ai_loading");
    _loading.style.display = "flex";
    const _btn_submit_ask_info = document.querySelector(".ai-form-btn");
    _btn_submit_ask_info.style.display = "none";

    const payload = {};
    payload.product_id = _btn_submit_ask_info.dataset.produuct;
    payload.product_name = _btn_submit_ask_info.dataset.productName;
    payload.email = _email.value;
    payload.phone_number = _phone_code[_phone_code.selectedIndex].text + _phone_number.value;
    payload.message = _message.value;
    const url = "https://easterncurator-app.vercel.app/api/askinfo";
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then(async (response) => {
            console.log(response);
            _loading.style.display = "none";
            _btn_submit_ask_info.style.display = "none";
            _success_message.style.display = "block";
        });
}

init_ask_info();